export const getDealCheckerShareData = () => {
  if (typeof window === 'undefined') return null;

  const urlObj = new URL('/lease-deals/', window.location.origin);
  urlObj.searchParams.set('utm_source', 'hidden_gems_share');
  urlObj.searchParams.set('utm_account', 'edmunds');
  urlObj.searchParams.set('utm_content', 'deal_checker');
  urlObj.hash = 'lease-deals-deal-checker';

  return {
    title: 'Are you getting a good deal? Rate your lease quote on Edmunds',
    url: urlObj.toString(),
  };
};
